import { BaseService } from '@services/BaseService';

class ApiService extends BaseService {
  constructor() {
    super('');
  }

  getVersion(): Promise<string> {
    return this.fetch<string>(
      'version',
      {
        method: 'GET'
      },
      false,
      true
    );
  }

  getEnvironment(): Promise<string> {
    return this.fetch<string>(
      'environment',
      {
        method: 'GET'
      },
      false,
      true
    );
  }
}

export const apiService = new ApiService();



// WEBPACK FOOTER //
// ./src/_services/ApiService.ts